var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-detail" },
    [
      _c(
        "el-form",
        _vm._b(
          { ref: "formRef", attrs: { model: _vm.form } },
          "el-form",
          _vm.formConfig,
          false
        ),
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品详情：" } },
            [
              _c("el-alert", {
                staticClass: "image-upload-tip",
                attrs: {
                  closable: false,
                  title: "建议上传分辨率为750×高度随机的图片，大小≤5MB",
                  type: "warning",
                  "show-icon": "",
                },
              }),
              _vm._v(" "),
              _c("Tinymce", {
                staticClass: "editer",
                attrs: { sourceType: "spu2" },
                model: {
                  value: _vm.form.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }